import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { noWhitespaceValidator } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-copy-project-scenario',
  templateUrl: './copy-project-scenario.component.html',
  styleUrls: ['./copy-project-scenario.component.scss'],
})
export class CopyProjectScenarioComponent {
  selectedFiles: any;
  isShowChange = false;
  imageUrl: any;
  scenarioData: any;
  @Output() saveCopyProjectScenarioEvent = new EventEmitter<any>();
  submitted: any;
  scenarioCopyForm!: FormGroup;
  fileBase64: any;
  copyProjects: any;
  statusItems: any;
  packageItems: any;
  modalLabel: any;
  selectedProduct: any;
  copiedProject: any;
  isProductContent: any;

  constructor(private modal: CustomModalService, private formBuilder: FormBuilder) {
    this.scenarioData = this.modal?.modalService?.config?.initialState?.['copyScenarioData'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.statusItems = this.scenarioData.statusItems;
    this.packageItems = this.scenarioData.productSectorItems;
    this.copyProjects = this.scenarioData.copyProjectItems;
    this.productSectorContent();
    this.setCopyProjects();
  }

  ngOnInit() {
    this.scenarioCopyForm = this.formBuilder.group({
      projectName: [
        this.scenarioData.name,
        [Validators.required, noWhitespaceValidator, Validators.maxLength(50)],
      ],
      projectNameForReport: [
        this.scenarioData.shortScenarioName,
        [Validators.required, noWhitespaceValidator, Validators.maxLength(15)],
      ],
      status: [this.scenarioData.senarioStatusId, Validators.required],
      copyProject: [this.scenarioData.copyProjectId, Validators.required],
    });
    this.setFormData();
  }

  commonInputSearch(term: string, item: any) {
    return item?.name.toLowerCase().includes(term.toLowerCase());
  }

  onClose() {
    this.modal.close();
  }

  async setCopyProjects() {
    await this.copyProjects?.map((item: any) => {
      if (item.idStr == this.scenarioData.copyProjectId) {
        return (this.copiedProject = item);
      }
    });
  }

  async productSectorContent() {
    await this.scenarioData?.productSectorItems?.map((item: any) => {
      if (item.id == this.scenarioData.sectorIdentifierId) {
        return (this.selectedProduct = item);
      }
    });
  }

  setFormData() {
    this.scenarioCopyForm.patchValue({ copyProject: this.copiedProject });
  }

  fileChangeEvent(event: any) {
    const reader = new FileReader(); // HTML5 FileReader API
    this.selectedFiles = event.target.files[0].name;
    this.isShowChange = this.selectedFiles ? true : false;
    const file = event.target.files[0];
    const mimeType = file?.type;
    if (mimeType?.match(/image\/*/) == null) {
      return;
    } else {
      if (event.target.files && event.target.files[0]) {
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.imageUrl = reader.result;
          this.fileBase64 = this.imageUrl.split(',')[1];
        };
      }
    }
  }

  getScenarioName(scenarioName: any) {
    this.scenarioCopyForm.controls['projectNameForReport'].setValue(scenarioName);
  }

  onSave() {
    this.submitted = true;
    if (this.scenarioCopyForm.valid) {
      const payload = {
        scenarioName: this.scenarioCopyForm.controls['projectName'].value,
        name: this.scenarioCopyForm.controls['projectName'].value,
        shortScenarioName: this.scenarioCopyForm.controls['projectNameForReport'].value,
        senarioStatusId: this.scenarioCopyForm.controls['status'].value || 0,
        scenarioTypeId: 1,
        projectId: this.scenarioData.projectId,
        copyProjectId:
          Number(this.scenarioCopyForm.controls['copyProject'].value?.idStr) ||
          this.scenarioData.copyProjectId,
        productId: this.scenarioData?.productId,
        productPackageScenarioId: this.scenarioData.productPackageScenarioId,
        scenarioId: this.scenarioData.scenarioId,
        sectorIdentifierId: this.scenarioData?.sectorIdentifierId,
      };
      this.saveCopyProjectScenarioEvent.emit(payload);
      this.onClose();
    }
  }

  removeImage() {
    this.isShowChange = false;
    this.selectedFiles = null;
    this.fileBase64 = null;
  }
}
